import { PasskeysQueryKeys } from '../../queryKey';
import {
  UseUserHasPassKeyQueryKeyProps,
  UseUserHasPassKeyQueryProps,
} from './props';
import { useQuery } from '@tanstack/react-query';
import { fetchUserHasPassKey } from './service';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { useDebounce } from '@starsoft/common/hooks';
import { UserHasPasskeyQueryDto } from '@/services/dto/passkey/user-has-passkey-query.dto';

export function useUserHasPassKey({ email }: UseUserHasPassKeyQueryProps) {
  const debouncedEmail = useDebounce(email);
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(debouncedEmail);

  const filter: UserHasPasskeyQueryDto = {
    email: debouncedEmail,
  };

  const queryKey: UseUserHasPassKeyQueryKeyProps = [
    PasskeysQueryKeys.UserHasPasskey,
    filter,
  ];

  const { data, isPending, error, refetch, fetchStatus } = useQuery<
    boolean,
    AxiosError<GenericError>,
    boolean,
    UseUserHasPassKeyQueryKeyProps
  >({
    queryKey,
    queryFn: fetchUserHasPassKey,
    enabled: isEmailValid,
    staleTime: 6 * 1000 * 60,
  });

  return {
    userHasPassKey: data,
    error,
    refetch,
    isPending: isPending && fetchStatus !== 'idle',
  };
}
